import axios from "axios";
import { useState } from "react";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import BaseLayout from "../../layouts/BaseLayout";
import { BASE_URL } from "../../utils/Element";
import AddContractToClosedData from "./components/AddContractToClosedData";

const initialData = {
  property_id: "",
  property_name: "",
  executed_loi: "",
  purchase_agreement_draft_distributed: "",
  executed_purchase_agreeement: "",
  transaction_timeline_distributed: "",
  earnest_deposite_confirmed: "",
  due_diligence_delivery_receipt_confirmed: "",
  title: "",
  address_title_issues: "",
  cordinate_inspection: "",
  survey_received: "",
  environmental_report_received: "",
  appraisal_received: "",
  negotiate_repairs: "",
  due_diligence_expiration_date: "",
  estoppel_snda_ordered: "",
  financing_approval: "",
  building_insurance_obtained: "",
  estoppel_snda_received: "",
  scheduled_closing: "",
  comission_invoice_wiring_instruction: "",
  review_settlement_statement: "",
  closed_date: "",

  // Add all _days fields here with default empty string
  earnest_deposite_confirmed_days: "",
  due_diligence_delivery_receipt_confirmed_days: "",
  title_days: "",
  address_title_issues_days: "",
  due_diligence_expiration_date_days: "",
  financing_approval_days: "",
  scheduled_closing_days: "",
};

const AddContractToClosed = () => {
  const [config] = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialData);

  const handleClose = () => {
    setFormData(initialData);
    setError({});
    setDisable(false);
    navigate("/contact-close");
  };

  // Validation: If date is filled → days must also be filled
  const validateDependentDates = () => {
    const newErrors = {};
    let hasError = false;

    const checks = [
      { date: "earnest_deposite_confirmed", days: "earnest_deposite_confirmed_days", label: "Earnest Deposit Confirmed" },
      { date: "due_diligence_delivery_receipt_confirmed", days: "due_diligence_delivery_receipt_confirmed_days", label: "Due Diligence Delivery Confirmed" },
      { date: "title", days: "title_days", label: "Title" },
      { date: "address_title_issues", days: "address_title_issues_days", label: "Address Title Issues" },
      { date: "due_diligence_expiration_date", days: "due_diligence_expiration_date_days", label: "Due Diligence Expiration Date" },
      { date: "financing_approval", days: "financing_approval_days", label: "Financing Approval" },
      { date: "scheduled_closing", days: "scheduled_closing_days", label: "Scheduled Closing" },
    ];

    checks.forEach(({ date, days, label }) => {
      if (formData[date] && !formData[days]) {
        newErrors[days] = `Please enter ${label} days`;
        hasError = true;
      }
    });

    if (hasError) {
      setError((prev) => ({ ...prev, ...newErrors }));
      NotificationManager.error("Please fill the 'Days' field for every date you entered.");
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
     setDisable(true);

    const dataToSend = { ...formData };   // Send full formData (all keys will go)

    axios
      .post(`${BASE_URL}/contract-to-close`, dataToSend, config)
      .then((res) => {
        NotificationManager.success("Contract to Close added successfully!");
        handleClose();
      })
      .catch((err) => {
        setDisable(false);
        setError(err.response?.data?.errors || {});
        if (err.response?.data?.message) {
          NotificationManager.error(err.response.data.message);
        }
      });
  };

  return (
    <BaseLayout>
      <div className="contact-header">
        <p className="head-1 dark-H md:px-0 px-3">Add Contract To Close</p>
      </div>

      <AddContractToClosedData
        formData={formData}
        error={error}
        onSetFormData={setFormData}
        onSetError={setError}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        disable={disable}
      />
    </BaseLayout>
  );
};

export default AddContractToClosed;